const CONSTANT = {
  URL: "https://youtube.thorsteinsson.is/api",
  KEY: {
    ENTER: "Enter",
  },
  ERROR: {
    TITLE: "Connection Error!",
    TECHNICAL_MESSAGE: "Please contact technical support",
    NOT_FOUND_MESSAGE: "Data Not Found :(",
    QUEUE_TITLE: "Queue will be cleared",
    QUEUE_MESSAGE: "Are you sure you want to close the player?",
    EMPTY_PLAYLIST: "Not Found",
  },
  ICON: {
    PLAYLIST: "Your Playlist",
    ADD_TO_QUEUE: "Add to queue",
    LIKE: "Like",
    DISLIKE: "Dislike",
    ADD_TO_PLAYLIST: "Add to playlist",
    BROWSING_HISTORY: "Browsing History",
    ADD: "Add",
    CLOSE: "Close",
    PLAY: "Play",
    DOWN_ARROW: "Down Arrow",
    DOT: "Dot",
  },
  VARIANT: {
    SMALL: "Small",
    NONE: "None",
  },
  CLOSE: "close",
  STATUS_KEY: {
    ADDED_TO_QUEUE: "ADDED_TO_QUEUE",
    UPDATED_PLAYLIST: "UPDATED_PLAYLIST",
    CREATED_PLAYLIST: "CREATED_PLAYLIST",
    REMOVE_PLAYLIST: "REMOVE_PLAYLIST",
  },
  STATUS_VALUE: {
    ADDED_TO_QUEUE: "Added to queue",
    UPDATED_PLAYLIST: "Updated your playlist",
    CREATED_PLAYLIST: "Created new playlist",
    REMOVE_PLAYLIST: "Remove your playlist",
  },
  LABEL: {
    CONFIRM: "Confirm",
    CANCEL: "Cancel",
  },
};

export default CONSTANT;
